import Image from 'next/image';

import * as S from './styles';

export const TESTIMONIAL_CARD_MARGIN = 4;
export const TESTIMONIAL_CARD_WIDTH = 320 + TESTIMONIAL_CARD_MARGIN * 2;

export type TestimonialProps = {
  companyName: string;
  logo: string;
  author: string;
  content: string;
  name: string;
};

export const TestimonialCard = (props: TestimonialProps) => {
  const { companyName, logo, author, content } = props;

  return (
    <S.Box
      className={`overflow-hidden mr-${TESTIMONIAL_CARD_MARGIN} ml-${TESTIMONIAL_CARD_MARGIN} shadow-2 rounded-xl display-inline-block border border-secondary-300 bg-neutral-50`}>
      <S.BoxHeader className="bg-secondary-50 layout-row layout-align-center-center">
        <Image src={logo} width={87} height={22} alt={`${companyName} logo`} quality={100} />
      </S.BoxHeader>
      <div className="layout-column layout-align-start-start p-8">
        <p className="small bg-primary-200 text-primary-500 py-1 px-3 rounded-xl">{companyName}</p>
        <p className="mt-4 text-secondary-700">{content}</p>
        <p className="mt-4 text-secondary-900 medium">{author}</p>
      </div>
    </S.Box>
  );
};
